import { parseDate, Time, toCalendarDateTime } from '@internationalized/date';
import { formatInTimeZone } from 'date-fns-tz';

export function isValidTimezone(timezone: string): boolean {
  try {
    Intl.DateTimeFormat(undefined, { timeZone: timezone });
    return true;
  } catch {
    return false;
  }
}

export function getDateTimeWithTimezone(
  date: string,
  time: Time,
  timeZoneId: string
): Date {
  const timezone = Intl.DateTimeFormat(undefined, {
    timeZone: timeZoneId
  }).resolvedOptions().timeZone;
  return toCalendarDateTime(parseDate(date), time).toDate(timezone);
}

export function formatTimeRangeAndTimezone(
  startDate: Date,
  endDate: Date,
  timeZoneId: string
) {
  const start = formatInTimeZone(startDate, timeZoneId, 'h:mm a');
  const end = formatInTimeZone(endDate, timeZoneId, 'h:mm a zzz');
  return `${start} - ${end}`;
}

export function getShortTimeWithTimezone(date: Date, timeZoneId: string) {
  return formatInTimeZone(date, timeZoneId, 'h:mm a zzz');
}
